import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CitizenRoutingModule } from './citizen-routing.module';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CitizenComponent } from './citizen.component';
import { SharedModule } from '../../common/shared/shared.module';


@NgModule({
  declarations: [CitizenComponent],
  imports: [
    CommonModule,
    RouterModule,
    CitizenRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  exports: [CitizenComponent]
})
export class CitizenModule { }
